const FETCH_BV_REVIEW_REQUEST = 'FETCH_BV_REVIEW_REQUEST'
const FETCH_BV_REVIEW_SUCCESS = 'FETCH_BV_REVIEW_SUCCESS'
const FETCH_BV_REVIEW_FAILURE = 'FETCH_BV_REVIEW_FAILURE'

export { FETCH_BV_REVIEW_REQUEST, FETCH_BV_REVIEW_SUCCESS, FETCH_BV_REVIEW_FAILURE }
